<template>
    <div>
      <p class="mb-1 mt-3">Acquista ora uno dei seguenti pacchetti: </p>
      <div class="cards-wrapper">
        <div class="price-card" v-for="(pkg, index) in packages" :key="index">
          <div class="price-card-body">
            <h5 class="title">{{ pkg.title }}</h5>
            <h6 class="subtitle">
              <del v-if="pkg.oldPrice">{{ shownValuta }} {{ pkg.oldPrice }}</del>
              {{ shownValuta }} {{ pkg.price }}
            </h6>
            <div class="btn-container">
              <button @click="redirectToRegister" class="mt-2 btn btn--shockwave">ACQUISTA ORA</button>
            </div>
            <p class="mt-5 info-text"><b>Premendo ACQUISTA ORA verrà creato automaticamente un account</b></p>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { ref, onMounted } from 'vue';
  import { useRoute } from 'vue-router';
  
  export default {
    setup() {
      const email = ref(null);
      const pwd = ref(null);
      const shownValuta = ref("€");
      const valuta = ref("");
      const route = useRoute();
  
      const packages = ref([
        { id: 3, title: "Email One - mensile", price: "8", oldPrice: null, isLifetime: false },
        { id: 4, title: "Email One - annuale", price: "29", oldPrice: "96", isLifetime: false },
        //{ id: 9, title: "Email One - Lifetime", price: "297", oldPrice: "6720", isLifetime: true }
      ]);
  
      const generatePassword = () => {
        const shuffle = str => [...str].sort(() => Math.random() - 0.5).join('');
        let strings = window.crypto.getRandomValues(new Uint32Array(2));
        strings = strings[0].toString(36) + strings[1].toString(36).toUpperCase();
        strings = shuffle(strings);
        strings = strings.match(/.{1,4}/g);
        pwd.value = `${strings[4]}-${strings[1]}-${strings[3]}`;
      };
  
      const redirectToRegister = () => {
        window.location.href = 'https://radar.cybetower.swiss/register';
      };
  
      onMounted(() => {
        generatePassword();
        if (typeof route.query.e !== 'undefined') {
          email.value = decodeURI(route.query.e);
        } else {
          email.value = "default@example.com"; // Use a default email if not provided
        }
  
        if (typeof route.query.s !== 'undefined') {
          valuta.value = String(decodeURI(route.query.s));
        }
  
        switch (valuta.value) {
          case "cnpUVm1HSE1wbHB6TlpkZHRBRmh2QT09":
            shownValuta.value = "€";
            break;
          case "VnFSazc0ZmZVZXNJaEZkT2lLZUt5dz09":
            packages.value[0].price = "7";
            packages.value[1].price = "27";
            packages.value[1].oldPrice = "84";
            packages.value[2].price = "297";
            packages.value[2].oldPrice = "6720";
            shownValuta.value = "CHF";
            break;
          case "dlJselBOVDAwbURwQXhudm4vWDJMdz09":
            shownValuta.value = "$";
            break;
          case "UG96VmR1V280d1czcXd3MWxQZHg5dz09":
            shownValuta.value = "£";
            break;
        }
      });
  
      return {
        email,
        pwd,
        shownValuta,
        packages,
        redirectToRegister
      };
    }
  };
  </script>
 
  <style scoped>
  .cards-wrapper {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 20px;
    margin: 3em auto;
    margin-top: 10px;
  }
  .price-card {
    color: #fff !important;
    background: #333;
    border-top-left-radius: 30px;
    border-bottom-right-radius: 30px;
    background-clip: padding-box;
    border: 3px solid #e8b923;
    z-index: 1;
  }
  @media only screen and (max-width: 730px) {
    .cards-wrapper {
      grid-template-columns: 100%;
    }
  }
  .price-card-body {
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    padding: 1.25rem;
  }
  .price-card-body .title {
    margin-bottom: .75rem;
    font-weight: 700;
  }
  .price-card-body .subtitle {
    margin-bottom: .5rem;
    display: flex;
    justify-content: space-evenly;
    font-size: 1.4rem;
  }
  .price-card-body .subtitle del {
    color: red;
  }
  .info-text {
    font-size: .8rem;
  }
  /* BUTTONS */
  .btn-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }
  .btn {
    width: 65%;
    line-height: 3rem;
    color: white;
    background: rgb(232,185,35);
    background: linear-gradient(0deg, rgba(232,185,35,1) 0%, rgba(244,243,59,1) 40%, rgba(251,251,141,1) 51%, rgba(244,243,59,1) 60%, rgba(232,185,35,1) 100%);
    color: #333;
    border-radius: 5px;
    text-align: center;
    margin: 1.6rem;
    font-weight: 700;
    letter-spacing: 2px;
    font-size: 0.9rem;
    border: none;
    padding: 0;
    position: relative;
    outline: none;
  }
  .btn.timeout {
    background: transparent;
    color: rgba(255,22,12,.75);
    margin: 1.6rem auto;
    margin-top: 0.5rem;
    font-size: 20px;
    border: 1px solid white;
    cursor: default;
  }
  .btn.btn--shockwave:hover {
    background: rgb(232,185,35);
  }
  .btn--shockwave.is-active {
    -webkit-animation: shockwaveJump 1s ease-out infinite;
    animation: shockwaveJump 1s ease-out infinite;
  }
  .btn--shockwave.is-active:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    border-radius: 5px;
    -webkit-animation: shockwave 1s 0.65s ease-out infinite;
    animation: shockwave 1s 0.65s ease-out infinite;
  }
  .btn--shockwave.is-active:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    border-radius: 5px;
    -webkit-animation: shockwave 1s 0.5s ease-out infinite;
    animation: shockwave 1s 0.5s ease-out infinite;
  }
  @-webkit-keyframes shockwaveJump {
    0% {
      transform: scale(1);
    }
    40% {
      transform: scale(1.08);
    }
    50% {
      transform: scale(0.98);
    }
    55% {
      transform: scale(1.02);
    }
    60% {
      transform: scale(0.98);
    }
    100% {
      transform: scale(1);
    }
  }
  @keyframes shockwaveJump {
    0% {
      transform: scale(1);
    }
    40% {
      transform: scale(1.08);
    }
    50% {
      transform: scale(0.98);
    }
    55% {
      transform: scale(1.02);
    }
    60% {
      transform: scale(0.98);
    }
    100% {
      transform: scale(1);
    }
  }
  @-webkit-keyframes shockwave {
    0% {
      transform: scale(1);
      box-shadow: 0 0 2px rgba(20, 242, 12, 0.15), inset 0 0 1px rgba(20, 242, 12, 0.15);
    }
    95% {
      box-shadow: 0 0 50px rgba(20, 242, 12, 0), inset 0 0 30px rgba(20, 242, 12, 0);
    }
    100% {
      transform: scale(2.25);
    }
  }
  @keyframes shockwave {
    0% {
      transform: scale(1);
      box-shadow: 0 0 2px rgba(20, 242, 12, 0.30), inset 0 0 1px rgba(20, 242, 12, 0.20);
    }
    95% {
      box-shadow: 0 0 50px rgba(20, 242, 12, 0), inset 0 0 30px rgba(20, 242, 12, 0);
    }
    100% {
      transform: scale(2.25);
    }
  }
  </style>
  